import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var BezierCurve01 = function BezierCurve01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10 7H3m18 0h-7m0 .252c3.4505.888 6 4.0202 6 7.7479m-16 0c0-3.7277 2.5496-6.8599 6-7.748M3.6 19h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 18.2401 6 17.9601 6 17.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 15 4.96 15 4.4 15h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 15.7599 2 16.0399 2 16.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 19 3.04 19 3.6 19m8-10h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C14 8.24 14 7.96 14 7.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.2401 5 12.9601 5 12.4 5h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 5.76 10 6.04 10 6.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.7599 9 11.0399 9 11.6 9m8 10h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 18.2401 22 17.9601 22 17.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 15 20.9601 15 20.4 15h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C18 15.7599 18 16.0399 18 16.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109M22 7c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1M4 7c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    })
  }));
};
export default BezierCurve01;